import { render, staticRenderFns } from "./ScanReview.vue?vue&type=template&id=34d9cfb8&"
import script from "./ScanReview.vue?vue&type=script&lang=js&"
export * from "./ScanReview.vue?vue&type=script&lang=js&"
import style0 from "./ScanReview.vue?vue&type=style&index=0&id=34d9cfb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports